export const MOOD_ICON_KEYS = [
  'positive',
  'tired',
  'low_mood',
  'healing',
  'focus',
  'celebrate',
] as const;

export type MoodIconKey = (typeof MOOD_ICON_KEYS)[number];

export const DEFAULT_MOOD_ICON_KEY: MoodIconKey = 'positive';

export const MOOD_ICON_LABELS: Record<MoodIconKey, string> = {
  positive: 'Tích cực',
  tired: 'Hơi mệt',
  low_mood: 'Tụt mood',
  healing: 'Chữa lành',
  focus: 'Tập trung',
  celebrate: 'Muốn vui vẻ',
};

export const MOOD_ICON_OPTIONS = MOOD_ICON_KEYS.map((value) => ({
  value,
  label: MOOD_ICON_LABELS[value],
}));

export function isMoodIconKey(value: unknown): value is MoodIconKey {
  return typeof value === 'string' && MOOD_ICON_KEYS.includes(value as MoodIconKey);
}

export function normalizeMoodIconKey(
  value: unknown,
  fallback: MoodIconKey = DEFAULT_MOOD_ICON_KEY
): MoodIconKey {
  return isMoodIconKey(value) ? value : fallback;
}
